/* eslint-disable import/prefer-default-export, camelcase */
import { coreService } from 'network-utils';
import { LearningPathNodeType, LearningPathNodeProps } from './learningPathInterfaces';

const CONTENT_TYPE_TO_NODE_TYPE: Record<coreService.LearningPathContentType, LearningPathNodeType> = {
    [coreService.LearningPathContentType.LESSON]: LearningPathNodeType.LESSON,
    [coreService.LearningPathContentType.COURSE]: LearningPathNodeType.COURSE,
    [coreService.LearningPathContentType.CHALLENGE]: LearningPathNodeType.CHALLENGE,
    [coreService.LearningPathContentType.SYSTEM_ASSESSMENT]: LearningPathNodeType.ASSESSMENT
};

export const contentTypeToNodeType = (contentType: coreService.LearningPathContentType): LearningPathNodeType =>
    CONTENT_TYPE_TO_NODE_TYPE[contentType] ?? LearningPathNodeType.MIXED;

export const convertStatus = (serverStatus: string): 'inProgress' | 'completed' | 'notStarted' => {
    switch (serverStatus) {
        case 'started':
            return 'inProgress';
        case 'completed':
            return 'completed';
        case 'not_started':
            return 'notStarted';
        default:
            return 'notStarted';
    }
};

export const progressOrder = ['inProgress', 'notStarted', 'completed'];

const TENANT_HIDDEN_LEARNING_PATH_UUIDS: Record<string, string[]> = {
    apple: ['8530678b-f7d3-4f43-bc8d-a97847d95ec8', '61db0629-7261-4c74-94ef-20fc8711e7fc'] // prod & dev
};

export const filterHiddenLearningPaths = <T extends { uuid?: string }>(
    paths: T[] | undefined | null,
    tenantName: string | undefined | null
): T[] => {
    if (!paths) return [];
    const hidden = TENANT_HIDDEN_LEARNING_PATH_UUIDS[tenantName ?? ''];
    if (!hidden || hidden.length === 0) return paths;
    return paths.filter(p => !p.uuid || !hidden.includes(p.uuid));
};

export const convertNumber = (num: number): string => {
    if (num >= 1000) {
        const roundedNumber = Math.floor(num / 100) / 10;
        return `${roundedNumber}K`;
    }
    return num.toString();
};

export const convertTimeFormat = (mins: number): string => {
    const hours = Math.floor(mins / 60);
    const remainingMinutes = mins % 60;
    return `${hours}:${remainingMinutes}`;
};

export const formatFullTime = (mins: number): string => {
    const hours = Math.floor(mins / 60);
    const remainingMinutes = mins % 60;
    return `${hours}h:${remainingMinutes}min`;
};

export const getNodePoints = (node: Pick<LearningPathNodeProps, 'score' | 'potentialScore'>): number =>
    node.score || node.potentialScore;
